angular.module('admin.directives')

.directive('datasourceViewer', ['HomeService', function(HomeService){
  return {
    controllerAs: 'datasourceViewerCtrl',
    bindToController: {
      street: '@',
      unit: '@',
      zip: '@',
      homeId: '@'
    },
    scope: {},
    restrict: 'E',
    templateUrl: '/admin/templates/partials/datasource-viewer.html',
    controller: function(){
      var ctrl = this;

      ctrl.refreshData = function(){
        ctrl.err = false;
        ctrl.jsonData = false;
        ctrl.loading = true;

        if(!ctrl.homeDataView)
          return onSuccess();

        if(!ctrl.street || !ctrl.zip)
          return onError('Street and Zip are required.');

        return HomeService.lookupByDatasource({
            homeId: ctrl.homeId,
            format: getFormat(),
            source: getSource(),
            street: ctrl.street,
            unit: ctrl.unit,
            zip: ctrl.zip,
          })
          .then(onSuccess)
          .catch(onError);
      };

      function onSuccess(home){
        ctrl.jsonData = home || null;
        ctrl.loading = false;
      };

      function onError(err){
        ctrl.err = err;
        ctrl.loading = false;
      };

      function getSource(){
        return ctrl.homeDataView.split('|')[0];
      };

      function getFormat(){
        return ctrl.homeDataView.split('|')[1];
      }
    }
  }
}]);
